
import dayjs from 'dayjs' // 时间转换
import userCountry from '~/components/login/userCountry.vue' // 国家
export default {
  components: { userCountry },
  props: {
    servicetypedata: {
      // 主要服务
      type: Object,
      default: () => {}
    },
    subservicetypedata: {
      // 次要服务
      type: Array,
      default: () => []
    }
  },
  data() {
    const code = []
    const name = []
    this.subservicetypedata.forEach((item) => {
      code.push(item.serviceCode)
      name.push(item.serviceName)
    })
    return {
      roTade: false,
      ruleForm: {
        serviceTypeCode: this.servicetypedata.serviceCode,
        serviceTypeCodetext: this.servicetypedata.serviceName,
        subServiceTypeCode: [...code],
        subServiceTypeCodetext: name.join(','),
        companyCountryCode: '',
        name: ''
      },
      rules: {
        companyName: [
          {
            required: true,
            message: this.$v('请输入企业名称'),
            trigger: 'blur'
          }
        ],
        companyShortName: [
          {
            required: true,
            message: this.$v('请输入企业简称'),
            trigger: 'blur'
          }
        ],
        companyWebSite: [
          {
            required: true,
            message: this.$v('请输入官方网址'),
            trigger: 'blur'
          }
        ],
        companyFoundDate: [
          {
            required: !this.$store.state.mobile,
            message: this.$v('请选择成立时间'),
            trigger: 'blur'
          }
        ],
        name: [{ required: true, message: this.$v('请选择注册地址') }],
        companySize: [
          {
            required: true,
            message: this.$v('请选择企业规模'),
            trigger: 'blur'
          }
        ],
        contactInfo: [
          {
            required: true,
            message: this.$v('请输入保密邮箱'),
            trigger: 'blur'
          },
          {
            type: 'email',
            message: this.$v('请输入正确的邮箱地址'),
            trigger: ['blur', 'change']
          }
        ],
        subServiceTypeCodetext: [{ required: true, message: '', trigger: 'blur' }],
        serviceTypeCodetext: [
          {
            required: this.subservicetypedata.length > 0,
            message: '',
            trigger: 'blur'
          }
        ]
      },
      createmode: [
        {
          name: '0-20',
          value: 1
        },
        {
          name: '21-50',
          value: 2
        },
        {
          name: '51-100',
          value: 3
        },
        {
          name: '101-200',
          value: 4
        },
        {
          name: '201-500',
          value: 5
        },
        {
          name: '500+',
          value: 6
        }
      ],
      value: '',
      minDate: new Date(1978, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(2021, 0, 17),
      firstLoad: true, // 是否为首次加载该组件
      pickershow: false // 移动时间选择器是否显示
    }
  },
  watch: {
    roTade(newV) {
      // 监听国家下拉框
      if (!newV || !this.firstLoad) return false // 收起或非首次展开下拉框时，不执行后续操作
      this.firstLoad = false // 当首次展开下拉框时，需要执行以下操作，后续无需执行
      this.$nextTick(() => {
        this.$refs.userCountry._scrollInit()
        this.$refs.userCountry.getHeight()
      })
    },
    ruleForm: {
      handler(newValue, oldValue) {
        this.$emit('createform', newValue)
      },
      deep: true
    }
  },
  mounted() {
    document.addEventListener('click', this.coutryClose, { passive: true })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.coutryClose)
  },
  methods: {
    coutryClose(e) {
      // 点击非组件区域关闭下拉框
      this.roTade = false
    },
    opencontry() {
      this.roTade = true
      this.$nextTick(() => {
        this.setscroll()
        console.log(this.$store.state.usergetCountry, 1123)
      })
    },
    setuserCountry(v) {
      this.roTade = false
      this.ruleForm.companyCountryCode = v.countryCode
      this.ruleForm.name = v.name
    },
    opentime() {
      this.pickershow = true
    },
    gettime() {
      console.log(this.currentDate)
      this.ruleForm.companyFoundDate = dayjs(new Date(this.currentDate)).format('YYYY-MM-DD')
      this.pickershow = false
    },
    renew() {
      const code = []
      const name = []
      this.subservicetypedata.forEach((item) => {
        code.push(item.serviceCode)
        name.push(item.serviceName)
      })
      this.ruleForm.subServiceTypeCode = [...code]
      this.ruleForm.subServiceTypeCodetext = name.join(',')
      this.ruleForm.serviceTypeCode = this.servicetypedata.serviceCode
      this.ruleForm.serviceTypeCodetext = this.servicetypedata.serviceName
    },
    setscroll() {
      const ele = document.querySelectorAll('.create-service')[0]
      ele.scrollTop = 500
    }
  }
}
